module.exports = __webpack_public_path__ + "static/media/110.61ed089a.jpg";